import type { CityConfig } from "../city-template/types";

export const rocklandConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Knox County Clerk", href: "https://www.knoxcountymaine.gov/", description: "Knox County Clerk — marriage license issuance" },
    { label: "Divorce Records — Knox County Clerk", href: "https://www.knoxcountymaine.gov/", description: "Knox County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Rockland",
  state: "Maine",
  stateAbbr: "ME",
  slug: "rockland",
  route: "/rockland",
  title: "Emergency Passport Rockland, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Rockland, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Rockland, Thomaston, Owls Head, Camden, and Knox County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Rockland, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Rockland and Knox County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rockland%20Maine%20working%20harbor%20with%20lobster%20boats%20and%20fishing%20fleet%2C%20historic%20downtown%20with%20brick%20buildings%20along%20Water%20Street%2C%20Maine%20lobster%20coast%20with%20granite%20docks%20and%20fishing%20piers%2C%20classic%20New%20England%20working%20waterfront%20with%20blue%20sky%20and%20calm%20harbor%2C%20summer%20afternoon%20light%2C%20professional%20travel%20photography%2C%20wide%20angle%20scenic%20view%20of%20Rockland%20Maine%20harbor&width=1800&height=700&seq=rockland-me-hero-001&orientation=landscape",
  heroImageAlt: "Rockland Maine working harbor with lobster boats and historic downtown",
  geoPosition: "44.1037;-69.1089",
  geoPlacename: "Rockland, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 185 miles (3.5 hours) from Rockland, ME",
  },
  nearbyCitiesZips: [
    { name: "Rockland", zips: "04841" },
    { name: "Thomaston", zips: "04861" },
    { name: "Owls Head", zips: "04854" },
    { name: "Camden", zips: "04843" },
    { name: "Rockport", zips: "04856" },
    { name: "Lincolnville", zips: "04849" },
    { name: "Warren", zips: "04864" },
    { name: "Hope", zips: "04847" },
    { name: "South Thomaston", zips: "04858" },
    { name: "Cushing", zips: "04563" },
    { name: "St. George", zips: "04860" },
    { name: "Union", zips: "04862" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Rockland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Bangor", route: "/bangor" },
    { name: "Emergency passport help in Ellsworth", route: "/ellsworth" },
    { name: "Urgent passport services in Camden", route: "/camden" },
    { name: "Same-day passport help in Belfast", route: "/belfast" },
    { name: "Expedited passport services in Portland", route: "/portland-me" },
    { name: "Passport courier services in Augusta", route: "/augusta-me" },
    { name: "Rush passport help in Waterville", route: "/waterville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Rockland, Maine remotely via secure courier. We do not have a walk-in office in Rockland — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Rockland travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Rockland and Knox County lobster coast",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Rockland and Knox County. From the working harbor on Penobscot Bay to the winding coastal roads of Owls Head and the art galleries of downtown — we help Rockland travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Rockland neighborhoods and nearby towns including Thomaston, Owls Head, Camden, Rockport, Lincolnville, Warren, Hope, South Thomaston, Cushing, St. George, and Union.",
  howItWorksIntro: "Most Rockland travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine coastal travelers who need fast, reliable results.",
  mistakesIntro: "Rockland is a busy working harbor town with a growing arts and tourism scene. Residents and summer visitors often need passports at short notice. Here are the most common mistakes we see from Rockland-area travelers.",
  testimonialsIntro: "Rockland travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Rockland? Here are the most common ones we hear from Knox County and Penobscot Bay travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Rockland international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Maria L.",
      location: "Rockland, ME",
      rating: 5,
      text: "I run a lobster business and need to travel to Canada for trade shows. Realized my passport was expired 5 days before my flight. Fast Passport Center got it renewed in 4 days. The process was completely remote — no driving to Portland.",
      service: "Passport Renewal",
    },
    {
      name: "David F.",
      location: "Thomaston, ME",
      rating: 5,
      text: "Emergency family trip to Ireland. I was panicking because I hadn't renewed my passport. Fast Passport Center handled everything in 48 hours. From Thomaston to Ireland in under a week — incredible service.",
      service: "Emergency Passport",
    },
    {
      name: "Karen S.",
      location: "Owls Head, ME",
      rating: 5,
      text: "My daughter's passport was lost right before our cruise to the Caribbean. Fast Passport Center helped with the DS-64 form and got a replacement in 3 days. They even walked us through the local acceptance clerk appointment.",
      service: "Lost Passport",
    },
    {
      name: "Robert J.",
      location: "Rockport, ME",
      rating: 5,
      text: "Passport renewal for our grandson's passport before his school trip to Quebec. Fast Passport Center made the process easy for the whole family. Documents shipped from Rockland, passport back in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "rockland-1",
      name: "Rockland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "270 Main St",
      city: "Rockland",
      state: "ME",
      zip: "04841",
      phone: "(207) 594-2255",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Rockland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main passport acceptance facility for Rockland and Knox County. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "rockland-2",
      name: "Camden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Chestnut St",
      city: "Camden",
      state: "ME",
      zip: "04843",
      phone: "(207) 236-3569",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from Rockland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular mid-coast option with reliable appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "rockland-3",
      name: "Thomaston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Main St",
      city: "Thomaston",
      state: "ME",
      zip: "04861",
      phone: "(207) 354-2163",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles from Rockland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Thomaston and South Thomaston residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rockland-4",
      name: "Bangor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Pendleton St",
      city: "Bangor",
      state: "ME",
      zip: "04401",
      phone: "(207) 945-3611",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles from Rockland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the region. More appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "rockland-5",
      name: "Rockland City Hall",
      type: "Municipal Passport Acceptance",
      address: "270 Pleasant St",
      city: "Rockland",
      state: "ME",
      zip: "04841",
      phone: "(207) 594-0300",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "In downtown Rockland",
      website: "https://www.rocklandmaine.gov/",
      websiteLabel: "Rockland City Hall",
      notes: "City clerk services. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "rockland-6",
      name: "Augusta Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Western Ave",
      city: "Augusta",
      state: "ME",
      zip: "04330",
      phone: "(207) 622-3139",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles from Rockland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "State capital facility with reliable appointment availability. Backup option.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local Rockland photo shops may use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Rockland acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Rockland applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Rockland families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Rockland travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Rockland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rockland address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Rockland, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Rockland in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Rockland travelers.",
    },
    {
      q: "Can I get a same-day passport in Rockland, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option.",
    },
    {
      q: "Where can I get a fast passport renewal in Rockland, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Rockland with no office visit required. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest. We serve all Rockland neighborhoods and Knox County communities.",
    },
    {
      q: "How far is Rockland from the Boston Passport Agency?",
      a: "Rockland is approximately 185 miles from the Boston Passport Agency — about a 3.5-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities.",
    },
    {
      q: "What acceptance facilities are near Rockland, Maine?",
      a: "Options near Rockland include the Rockland Post Office (04841), Camden Post Office (04843), Thomaston Post Office (04861), and Rockland City Hall (04841). The Rockland Post Office on Main St is the most convenient option.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery. You only need to visit a local acceptance clerk if you're a first-time applicant.",
    },
    {
      q: "Is Rockland near any airports?",
      a: "Rockland is about 70 miles from Bangor International Airport (BGR) and about 75 miles from Portland International Jetport (PWM). Knox County Regional Airport (RKD) in Owls Head offers small regional flights. Most Rockland travelers use Bangor or Portland for international flights.",
    },
    {
      q: "How much does expedited passport service cost in Rockland?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote.",
    },
    {
      q: "What documents do I need for a first-time passport in Rockland?",
      a: "You'll need proof of citizenship, government-issued photo ID, two passport photos, and payment. We provide a complete checklist and review your documents before your acceptance clerk visit.",
    },
    {
      q: "Can you help with a child's passport in Rockland?",
      a: "Yes. Child passports require both parents (or notarized consent), the child's birth certificate, and both parents' IDs. We walk Rockland families through the entire process.",
    },
    {
      q: "Is there a UPS Store near Rockland for shipping documents?",
      a: "The nearest UPS drop-off locations are in Thomaston or Belfast. We provide a prepaid overnight label — just drop your package at any UPS location. You can also schedule a pickup.",
    },
    {
      q: "Can I get passport photos taken in Rockland?",
      a: "Yes, Rite Aid on Main St and CVS on Park St in Rockland offer passport photo services. Larger pharmacy options are also available in Camden, Thomaston, and Belfast.",
    },
  ],
  photoLocations: [
    { name: "Rite Aid — Rockland", address: "270 Main St, Rockland, ME 04841", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Rockland", address: "75 Park St, Rockland, ME 04841", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Camden", address: "115 Elm St, Camden, ME 04843", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Rite Aid — Belfast", address: "125 Northport Ave, Belfast, ME 04915", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Bangor", address: "30 Main St, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Photo Center — Bangor", address: "60 Skyway Dr, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Augusta", address: "70 Western Ave, Augusta, ME 04330", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Rite Aid — Thomaston", address: "15 Main St, Thomaston, ME 04861", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Rockland",
      address: "25 Water St, Rockland, ME 04841",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Knox County BMV. Online appointment booking available. Local option for Rockland area.",
      featured: true,
    },
    {
      name: "BMV — Belfast",
      address: "66 Union St, Belfast, ME 04915",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Waldo County option. 30 miles from Rockland.",
      featured: false,
    },
    {
      name: "BMV — Bangor",
      address: "45 Skyway Dr, Bangor, ME 04401",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. 70 miles from Rockland.",
      featured: false,
    },
    {
      name: "BMV — Augusta",
      address: "29 State House Station, Augusta, ME 04333",
      hours: "Mon–Fri: 8AM–5PM",
      note: "State capital full-service BMV. 55 miles from Rockland.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RKD",
      name: "Knox County Regional Airport",
      distance: "3 miles from Rockland (8 min)",
      address: "82 Airport Rd, Owls Head, ME 04854",
      note: "Small regional airport in Owls Head with limited commercial service. Seasonal flights to Boston operated by Cape Air. Useful for local connections.",
      flightUrl: "https://www.knoxcountyairport.com/",
      flightLabel: "Knox County Airport",
      featured: false,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "70 miles from Rockland (75 min)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Closest major airport to Rockland with direct flights to Boston, New York, Philadelphia, and seasonal Florida routes. Best option for most Rockland travelers.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: true,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "75 miles from Rockland (80 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's largest airport with the most flight options. Worth considering for direct international connections.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: false,
    },
  ],
};